export enum OutletNameEnum {
  SENT_EMAILS = 'sent-emails',
}
